<!--<div class="container">-->
<!--  <div class="row">-->
<!--    <div class="col">-->

      <div class="input-group">
        <ng-template [ngIf]="!displayContent"><button class="input-group-addon" type="button" (click)="showContent()"><i class="fad fa-caret-square-down fa-lg"></i></button></ng-template>
        <ng-template [ngIf]="displayContent"><button class="input-group-addon" type="button" (click)="hideContent()"><i class="fad fa-caret-square-up fa-lg"></i></button></ng-template>
<!--        <div #controlContent resizeListener (resizeEvent)="onResize($event)" class="form-control" style="background-color: white;" (click)="toggleContent()" >-->
        <div #controlContent class="form-control" style="background-color: white;" (click)="toggleContent()" >
<!--        <div #controlContent class="form-control" style="background-color: white;" (click)="toggleContent()" >-->
          <ng-template [ngIf]="selected.length<=nbSelectedMax"><span [style.line-height]="doubleLine ? '200%':'98%'">
            <span class="item-contour" *ngFor="let item of selected">
              {{item.data.name}} <a class="naked muted" (click)="unSelectItem($event,item)">x</a>
            </span>
          </span></ng-template>
          <ng-template [ngIf]="selected.length>nbSelectedMax"><span class="muted">{{selectedLabel}}</span></ng-template>
          <ng-template [ngIf]="selected.length===0"><span class="muted">{{selectPlaceHolder}}</span></ng-template>
        </div>
      </div>

      <div class="dropdown-list" style="overflow-y: scroll; max-height: 400px;" [hidden]="!displayContent">
        <ng-template [ngIf]="!selectableModel || selectableModel.length===0 "><div class="muted" style="padding:10px;">{{noSelectionAvailable}}</div></ng-template>
        <ul>
          <li *ngFor="let item of selectableModel; let idx=index" >
            <label class="form-check-label">
              <input type="checkbox" name="{{idx}}" class="form-check-input" [ngModel]="item.selected" (click)="onItemChanged(item)" > {{item.data.name}}
<!--              {{item.data.name}} {{item.selected}}-->
<!--              <input class="form-check-input" type="checkbox" [(ngModel)]="bean.data.selected">-->
            </label>
          </li>
        </ul>
      </div>
<!--    </div>-->
<!--  </div>-->
<!--</div>-->
